import React, { FunctionComponent } from "react";
import styles from "./Logos.module.scss";
import LogosBlockProps from "./LogosProps.interface";

import useStyles from "./hooks/useStyles";

import Logo from "./components/Logo/Logo";
import combineClasses from "helpers/combine-classes";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import useAnchor from "blocks/hooks/useAnchor";

const Logos: FunctionComponent<LogosBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const wrapperStylesElementRef = useStyles(props.settings);

    const listSizeClass = props.settings.listSize ? styles[props.settings.listSize] : undefined;

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    return (
        <section className={combineClasses(styles.wrapper, listSizeClass, ...wrapperClasses)} ref={wrapperStylesElementRef} id={identifier} style={{ ...wrapperStyles, ...splitStyles }}>
            <div className={combineClasses(styles.container, ...splitClasses)}>
                {props.content.logos && props.content.logos.length > 0 ? (
                    <div className={styles.list}>
                        {props.content.logos.map(logo => (
                            <Logo key={logo.contentUdi} {...logo} settings={props.settings} />
                        ))}
                    </div>
                ) : null}
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default Logos;